import {
  eventStartKey,
  eventEndInclusiveKey,
  isMultiDayEvent,
} from './calendar_grid_utils';

export const WEEK_MULTIDAY_MAX_LANES = 4;
export const WEEK_LANE_HEIGHT_PX = 17;
export const WEEK_LANE_GAP_PX = 2;
export const WEEK_LANE_PAD_TOP_PX = 2;
export const WEEK_LANE_PAD_BOTTOM_PX = 2;

/** Altura nominal de uma futura «banda» de lanes (não usada na vista mensal simplificada). */
export const DEFAULT_WEEK_MULTI_BAND_RESERVED_PX =
  WEEK_LANE_PAD_TOP_PX +
  WEEK_LANE_PAD_BOTTOM_PX +
  WEEK_MULTIDAY_MAX_LANES * WEEK_LANE_HEIGHT_PX +
  (WEEK_MULTIDAY_MAX_LANES - 1) * WEEK_LANE_GAP_PX;

export const weekMultiDayBandHeightPx = DEFAULT_WEEK_MULTI_BAND_RESERVED_PX;

/** Altura fixa só da linha do número do dia na célula mensal. */
export const DAY_HEADING_ROW_PX = 24;

/**
 * Topo fixo na linha virtualizada mensal (só o nº do dia). Eventos ocupam o restante da altura.
 * Mantém nome para imports existentes na virtualização (`react-window`).
 */
export const WEEK_TOP_ABOVE_TIMED_PX = DAY_HEADING_ROW_PX;

/**
 * Build overlapping multi-day segments for one week → greedy lane placements.
 */
export function computeWeekMultiDayPlacements(weekKeys, events, seenIds = undefined) {
  const seen = seenIds ?? new Set();
  const segments = [];

  const wFirst = weekKeys[0];
  const wLast = weekKeys[6];

  events.forEach((event) => {
    if (!isMultiDayEvent(event)) return;
    const id = event.id ?? `${eventStartKey(event)}-${event.title}`;
    if (seen.has(id)) return;

    const SK = eventStartKey(event);
    const EK = eventEndInclusiveKey(event);
    if (!SK || !EK) return;
    if (EK < wFirst || SK > wLast) return;

    seen.add(id);

    let startCol;
    let endCol;
    for (let i = 0; i < 7; i++) {
      const k = weekKeys[i];
      if (k >= SK && k <= EK) {
        if (startCol === undefined) startCol = i;
        endCol = i;
      }
    }
    if (startCol === undefined || endCol === undefined) return;

    segments.push({
      event,
      startCol,
      endCol,
      startKey: SK,
      endKey: EK,
    });
  });

  const sorted = [...segments].sort((a, b) => {
    const c = a.startCol - b.startCol;
    if (c !== 0) return c;
    return b.endCol - b.startCol - (a.endCol - b.startCol);
  });

  const laneSpans = [];
  const placements = [];

  sorted.forEach((seg) => {
    let lane = 0;
    while (lane < laneSpans.length) {
      const occupied = laneSpans[lane];
      const clash = occupied.some(
        (o) => !(seg.endCol < o.startCol || o.endCol < seg.startCol)
      );
      if (!clash) break;
      lane++;
    }
    if (!laneSpans[lane]) laneSpans[lane] = [];
    laneSpans[lane].push({ startCol: seg.startCol, endCol: seg.endCol });
    placements.push({ ...seg, lane });
  });

  return placements;
}

